module.exports = __webpack_public_path__ + "img/close.5d18a5b9.svg";